// extracted by mini-css-extract-plugin
export default {"productGallery":"NH-z","inQuickShop":"OH-z"};